import _ from 'lodash';
import { ASSET_PATH_SEPARATOR } from '@/main/app.constants';
import type { HierarchyNodeOutputV1 } from '@/sdk/model/HierarchyNodeOutputV1';

export type PathComponent = {
  name: string;
  id: string;
  disabled: boolean;
  node?: HierarchyNodeOutputV1;
  nodePath?: HierarchyNodeOutputV1[];
};

interface PathComponentsIF {
  asset: any;
  nodePath?: HierarchyNodeOutputV1[];
  hierarchyName?: string;
  hierarchyId?: string;
  actionOnComponent: (component: PathComponent) => void;
}

export const PathComponents = (props: PathComponentsIF) => {
  const { asset, actionOnComponent, nodePath, hierarchyName, hierarchyId } = props;

  let pathComponents: PathComponent[] = [];
  if (nodePath && hierarchyName && hierarchyId) {
    pathComponents = [
      {
        name: hierarchyName,
        id: hierarchyId,
        disabled: false,
      },
      ...nodePath.map((node) => ({
        name: node.displayName!,
        id: node.columnId!,
        disabled: false,
        node,
        nodePath,
      })),
    ];
  } else {
    pathComponents = _.zipWith(
      _.split(asset.formattedName, ASSET_PATH_SEPARATOR),
      asset.pathComponentIds,
      asset.pathComponentDisabled,
      (name, id: string, disabled: boolean) => ({
        name,
        id,
        disabled,
      }),
    );
  }

  const getPathComponentSpan = (component: PathComponent) => (
    <span
      className={component.disabled ? 'sq-fairly-dark-gray disabledBehavior' : 'force-link-look cursorPointer'}
      data-stoppropagation="true"
      onClick={() => {
        actionOnComponent(component);
      }}>
      {component.name}
    </span>
  );

  return (
    <span data-testid="pathComponents" data-stoppropagation="true">
      {pathComponents
        .map((component) => getPathComponentSpan(component))
        .reduce((acc, c) =>
          acc === null ? (
            c
          ) : (
            <>
              {acc}{' '}
              {
                <span className="sq-fairly-dark-gray" data-stoppropagation="true">
                  {ASSET_PATH_SEPARATOR}
                </span>
              }{' '}
              {c}{' '}
            </>
          ),
        )}
    </span>
  );
};
